import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { reverse } from 'named-urls';

import routes from 'core/routes';

const ScheduleInstanceRedirect = (): React.ReactElement => {
  const { scheduleId, instanceId } = useParams<{ scheduleId: string; instanceId: string }>();

  return (
    <Navigate
      replace
      to={reverse(routes.dashboard.tasks.scheduleInstance, {
        scheduleId: scheduleId as string,
        instanceId: instanceId as string,
      })}
    />
  );
};

export default ScheduleInstanceRedirect;
